import {
  TEXT_ALIGNMENT_CENTER,
  TEXT_ALIGNMENT_LEFT,
} from '@wix/communities-forum-client-commons/dist/src/constants/text-alignment';

export enum TextAlignment {
  LEFT = TEXT_ALIGNMENT_LEFT,
  CENTER = TEXT_ALIGNMENT_CENTER,
}
